import { POP_OBJECT_FROM_STACK } from "./actionTypes";

export default (objectType, slug) => ({
  type: POP_OBJECT_FROM_STACK,
  payload: {
    objectType,
    slug
  }
});